import { Suspense } from 'react'
import { ErrorBoundary } from 'react-error-boundary'

import { getActionMetadata } from '../../hooks/navigation/categories/utils'
import { useService } from '../../lenteHooks'
import {
  CommandModalButtonRegisterTemplate,
  type CommandModalButtonRegisterTemplateProps,
} from './CommandModalButtonRegisterTemplate'

const CommandModalButtonRegisterWithWarnings = ({
  actionId,
  entityId,
  ...props
}: CommandModalButtonRegisterTemplateProps) => {
  const actionMetadata = useService('logic.actionMetadata')
  const metadata = getActionMetadata(actionMetadata, actionId)

  const warnings = metadata.useCreateWarnings?.(entityId)

  return (
    <CommandModalButtonRegisterTemplate
      actionId={actionId}
      entityId={entityId}
      warnings={warnings}
      {...props}
    />
  )
}

export const CommandModalButtonRegister = (
  props: CommandModalButtonRegisterTemplateProps,
) => {
  const Fallback = () => (
    <CommandModalButtonRegisterTemplate warnings={undefined} {...props} />
  )

  if (props.commandActionVariant !== 'create') {
    return (
      <CommandModalButtonRegisterTemplate warnings={undefined} {...props} />
    )
  }

  return (
    <ErrorBoundary FallbackComponent={Fallback}>
      <Suspense fallback={null}>
        <CommandModalButtonRegisterWithWarnings {...props} />
      </Suspense>
    </ErrorBoundary>
  )
}
